import React from "react";
import { withRouter } from "react-router-dom";
import Button from "../../components/buttons/Button";
import Text from "../../components/typography/Text";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";
import Image from "../../components/images/Image";

const Presentation = ({ image, title, items = [], link, history }) => {
  return (
    <div className="oHomePresentation">
      <div className="oHomePresentation_wrapper">
        <div className="oHomePresentation_block">
          <Image
            className="oHomePresentation_image"
            image={image}
            alt="Presentation image"
          />
        </div>
        <div className="oHomePresentation_block">
          <div className="oHomePresentation_content">
            <h4>{title}</h4>
            <ul>
              {items.map(({ item }, index) => (
                <li key={index}>
                  <Icon path={mdiCheck} size="16px" color="#FF4D3B" />
                  <Text>{item}</Text>
                </li>
              ))}
            </ul>
            <Button
              outlined
              rounded
              arrowRight
              onClick={() => (window.location.href = link.url)}
            >
              {link.title}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Presentation);
